<template>
    <div class="card-list">
        <div
            v-if="selectAll"
            class="card-list__item"
            :class="{ 'card-list__item--selected': allSelected }"
            @click="toggleAll"
        >
            <AppCheckbox :model-value="allSelected" />
            <span class="card-list__label font-weight-bold">{{ $t('components.cards.CheckboxCardList.selectAll') }}</span>
        </div>
        <div
            v-for="item in items"
            :key="item.value"
            class="card-list__item"
            :class="{ 'card-list__item--selected': isSelected(item), 'card-list__item--disabled': item.disabled }"
            @click="toggle(item)"
        >
            <AppCheckbox :model-value="isSelected(item)" :disabled="item.disabled" />
            <span class="card-list__label"><slot :item="item">{{ item.label }}</slot></span>
        </div>
    </div>
</template>
<script>
import AppCheckbox from "../form/checkbox/AppCheckbox.vue";

export default {
    name: "CheckboxCardList",
    components: { AppCheckbox },
    emits: ['update:modelValue'],
    props: {
        items: {
            type: Array,
            default: () => []
        },
        modelValue: {
            type: Array,
            default: () => []
        },
        selectAll: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        allSelected() {
            return this.items.length > 0 && this.items.every((item) => this.modelValue.includes(item.value));
        }
    },
    methods: {
        isSelected(item) {
            return this.modelValue.includes(item.value);
        },
        toggle(item) {
            if (item.disabled) {
                return;
            }

            const values = [...this.modelValue];
            const index = values.indexOf(item.value);

            if (index === -1) {
                values.push(item.value);
            } else {
                values.splice(index, 1);
            }

            this.$emit('update:modelValue', values);
        },
        toggleAll() {
            const values = this.allSelected ? [] : this.items.map((item) => item.value);

            this.$emit('update:modelValue', values);
        }
    }
}
</script>
<style scoped>
.card-list {
    display: flex;
    flex-direction: column;
    gap: 0.625rem;
}

.card-list__item {
    display: flex;
    align-items: center;
    gap: 1.25rem;
    width: 100%;
    padding: .75rem 1.25rem;
    border: 1px solid #dee2e6;
    border-radius: 0.1875rem;
    cursor: pointer;
    background-color: #fff;
    user-select: none;
    transition: border-color 0.15s ease, background-color 0.15s ease;
}

.card-list__item--selected {
    border-color: #2196F3;
    background-color: rgba(33, 150, 243, 0.06);
}

.card-list__item--disabled {
    cursor: not-allowed;
    opacity: 0.6;
}

.card-list__label {
    flex: 1;
}
</style>
